module.exports = __webpack_public_path__ + "static/media/bancoganadero.baccc058.jpeg";